import { NESTED_PANEL_BOTTOM_MARGIN, NESTED_PANEL_MIN_HEIGHT } from "./MenuConstants";

// Limita la altura del panel de nietos al espacio disponible hasta el borde inferior de la ventana
export const setNestedPanelMaxHeight = (event) => {
  const element = event.currentTarget;
  const availableHeight = window.innerHeight - element.getBoundingClientRect().top - NESTED_PANEL_BOTTOM_MARGIN;
  element.style.setProperty("--nestedPanelMaxHeight", `${Math.max(availableHeight, NESTED_PANEL_MIN_HEIGHT)}px`);
};
